<template>
  <div class="page">

    <!-- <div class="top">

      <div>
        Create new vulnerability
        <div class="form">
          <form class="form-inline" v-on:submit.prevent="createVulnerability()">
            <input v-model="value" size="50" placeholder="FileName"/>
            <input id="valueFileInput" type="file" @change="onFileChange" style="display: none;" />
            <input type="button" value="Upload file" onclick="document.getElementById('valueFileInput').click();" />
            <button type="submit">Create new</button>
          </form>          
        </div>
      </div>
    </div> -->

    <div class="vulnerabilities">
      <div class="top">
        <div>
          <!-- <span v-show="updateProgress < 100">Updating {{updateProgress}}% </span> -->
          <button @click="refreshVulnerabilities">Refresh</button>
        </div>
      </div>
      <!-- <Keyword v-for="keyword in filteredKeywords" :key="keyword.id" :keyword="keyword"/> -->
      <Vulnerability v-for="vulnerability in vulnerabilities" :key="vulnerability.id" :vulnerability="vulnerability"/>
    </div>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top {
  display: flex;
  justify-content: space-between;
}
.hint {
  font-size: small;
}
.search {
}
.keywords {
  margin-top: 10px;
}
.btn {
  margin-right: 3px;
}
</style>

<script>
import { mapState } from 'vuex'
import Vulnerability from '@/components/Vulnerability.vue'

export default {
  name: 'vulnerabilities',
  components: {
    Vulnerability
  },
  computed: {
    ...mapState([
      'debugMode',
      'apiAccount',
      'account',
      'profile',
      'vulnerabilities',
      'vulnerabilitiesFilter'
    ])
  },
  watch: {
    profile () {
      this.refreshVulnerabilities()
    }
  },
  mounted () {
    this.refreshVulnerabilities()
  },
  methods: {
    onFileChange (event) {
      if (event.target.files) {
        this.valueFile = event.target.files[0]
        this.value = this.valueFile.name
      }
    },
    refreshVulnerabilities () {
      if (!this.profile.id) return
      this.$store.dispatch('loadVulnerabilities')
    },
    // onValueChange () {
    //   document.getElementById('valueFileInput').value = null
    // },fvalue
    createVulnerability () {
      if (!this.value && !this.values) return
      this.$store.dispatch('createVulnerability', {
        type: this.type,
        value: this.value,
        value_file: this.valueFile
      })
      this.type = '' //#Don't reset the type
      this.value = ''
      this.valueFile = null
      this.refreshVulnerabilities()
      //document.getElementById('valueFileInput').value = null
    }
  },
  data () {
    return {
      type: '',
      value: '',
      valueFile: null,
      bulkMethod: ''
    }
  }
}
</script>
